var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 64,
    viewBox: "0 0 100 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8321 7.04625C74.2366 2.77051 67.823 0.458115 60.2422 0L57.2427 7.07897C63.2091 7.13351 69.5791 9.36955 75.2619 13.4053L79.8321 7.04625Z",
    fill: "#009BBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0058 27.6941L60.8967 27.6723C56.0429 26.5597 52.4761 25.5999 49.9456 24.2692L46.4661 32.4607C49.2148 33.5624 52.607 34.5549 57.3736 35.6566C66.1651 37.6854 73.1131 39.2779 73.1131 46.4987C73.1131 52.476 67.9648 56.3481 60.0023 56.3481C52.5634 56.3481 45.8117 54.003 39.3871 49.1601L36.2021 56.6535C42.7576 61.1583 50.7855 63.5362 59.4242 63.5362C73.6912 63.5362 82.5481 56.4136 82.5481 44.9498C82.5372 34.5768 74.6402 30.77 61.0058 27.6941Z",
    fill: "#009BBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 2.00696H92.583V61.4092H100V2.00696Z",
    fill: "#009BBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5251 0.0327148L20.3423 47.5894L24.6398 57.7116L49.1272 0.0327148H38.5251Z",
    fill: "#1F3158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6021 0.0327148H0L14.387 33.9332L19.2081 22.5349L10.6021 0.0327148Z",
    fill: "#1F3158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 63.5362,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4f4ea04df9b053c1f95145dc4df15a0.svg";
export { ForwardRef as ReactComponent };